import ICurrentUserState from "./ICurrentUserState";

export enum ISignupStateTypes {
  UPDATE_SIGNUP_FORM_DETAILS = "SIGNUP/UPDATE_SIGNUP_FORM_DETAILS",

  SEND_EMAIL_OTP_REQUEST = "SIGNUP/SEND_EMAIL_OTP_REQUEST",
  SEND_EMAIL_OTP_FAILURE = "SIGNUP/SEND_EMAIL_OTP_FAILURE",
  SEND_EMAIL_OTP_SUCCESS = "SIGNUP/SEND_EMAIL_OTP_SUCCESS",

  VERIFY_EMAIL_OTP_REQUEST = "SIGNUP/VERIFY_EMAIL_OTP_REQUEST",
  VERIFY_EMAIL_OTP_FAILURE = "SIGNUP/VERIFY_EMAIL_OTP_FAILURE",
  VERIFY_EMAIL_OTP_SUCCESS = "SIGNUP/VERIFY_EMAIL_OTP_SUCCESS",

  SEND_MOBILE_OTP_REQUEST = "SIGNUP/SEND_MOBILE_OTP_REQUEST",
  SEND_MOBILE_OTP_FAILURE = "SIGNUP/SEND_MOBILE_OTP_FAILURE",
  SEND_MOBILE_OTP_SUCCESS = "SIGNUP/SEND_MOBILE_OTP_SUCCESS",

  VERIFY_MOBILE_OTP_REQUEST = "SIGNUP/VERIFY_MOBILE_OTP_REQUEST",
  VERIFY_MOBILE_OTP_FAILURE = "SIGNUP/VERIFY_MOBILE_OTP_FAILURE",
  VERIFY_MOBILE_OTP_SUCCESS = "SIGNUP/VERIFY_MOBILE_OTP_SUCCESS",

  UPDATE_PROFESSIONAL_DETAILS_REQUEST = "SIGNUP/UPDATE_PROFESSIONAL_DETAILS_REQUEST",
  UPDATE_PROFESSIONAL_DETAILS_FAILURE = "SIGNUP/UPDATE_PROFESSIONAL_DETAILS_FAILURE",
  UPDATE_PROFESSIONAL_DETAILS_SUCCESS = "SIGNUP/UPDATE_PROFESSIONAL_DETAILS_SUCCESS",

  FETCH_SINGUP_TEAMS_SUCCESS = "SIGNUP/FETCH_SINGUP_TEAMS_SUCCESS",
  FETCH_SINGUP_SUB_TEAMS_SUCCESS = "SIGNUP/FETCH_SUB_SINGUP_TEAMS_SUCCESS",
  FETCH_SINGUP_DESIGNATIONS_SUCCESS = "SIGNUP/FETCH_SINGUP_DESIGNATIONS_SUCCESS",

  FR_VERIFY_REQUEST = "SIGNUP/FR_VERIFY_REQUEST",
  FR_VERIFY_FAILURE = "SIGNUP/FR_VERIFY_FAILURE",
  FR_VERIFY_SUCCESS = "SIGNUP/FR_VERIFY_SUCCESS",

  SIGNUP_UPLOAD_DOCUMENTS_REQUEST = "SIGNUP/SIGNUP_UPLOAD_DOCUMENTS_REQUEST",
  SIGNUP_UPLOAD_DOCUMENTS_FAILURE = "SIGNUP/SIGNUP_UPLOAD_DOCUMENTS_FAILURE",
  SIGNUP_UPLOAD_DOCUMENTS_SUCCESS = "SIGNUP/SIGNUP_UPLOAD_DOCUMENTS_SUCCESS",

  FETCH_SIGNUP_TERMS_AND_CONDITIONS_REQUEST = "SIGNUP/FETCH_SIGNUP_TERMS_AND_CONDITIONS_REQUEST",
  FETCH_SIGNUP_TERMS_AND_CONDITIONS_FAILURE = "SIGNUP/FETCH_SIGNUP_TERMS_AND_CONDITIONS_FAILURE",
  FETCH_SIGNUP_TERMS_AND_CONDITIONS_SUCCESS = "SIGNUP/FETCH_SIGNUP_TERMS_AND_CONDITIONS_SUCCESS",

  ACCEPT_SIGNUP_TERMS_AND_CONDITIONS_REQUEST = "SIGNUP/ACCEPT_SIGNUP_TERMS_AND_CONDITIONS_REQUEST",
  ACCEPT_SIGNUP_TERMS_AND_CONDITIONS_FAILURE = "SIGNUP/ACCEPT_SIGNUP_TERMS_AND_CONDITIONS_FAILURE",
  ACCEPT_SIGNUP_TERMS_AND_CONDITIONS_SUCCESS = "SIGNUP/ACCEPT_SIGNUP_TERMS_AND_CONDITIONS_SUCCESS",

  SUBMIT_BANK_DETAILS_REQUEST = "SIGNUP/SUBMIT_BANK_DETAILS_REQUEST",
  SUBMIT_BANK_DETAILS_FAILURE = "SIGNUP/SUBMIT_BANK_DETAILS_FAILURE",
  SUBMIT_BANK_DETAILS_SUCCESS = "SIGNUP/SUBMIT_BANK_DETAILS_SUCCESS",

  SUBMIT_EDUCATION_DETAILS_REQUEST = "SIGNUP/SUBMIT_EDUCATION_DETAILS_REQUEST",
  SUBMIT_EDUCATION_DETAILS_FAILURE = "SIGNUP/SUBMIT_EDUCATION_DETAILS_FAILURE",
  SUBMIT_EDUCATION_DETAILS_SUCCESS = "SIGNUP/SUBMIT_EDUCATION_DETAILS_SUCCESS",

  SUBMIT_LOCATION_DETAILS_REQUEST = "SIGNUP/SUBMIT_LOCATION_DETAILS_REQUEST",
  SUBMIT_LOCATION_DETAILS_FAILURE = "SIGNUP/SUBMIT_LOCATION_DETAILS_FAILURE",
  SUBMIT_LOCATION_DETAILS_SUCCESS = "SIGNUP/SUBMIT_LOCATION_DETAILS_SUCCESS",


  SUBMIT_SKILLS_DETAILS_REQUEST = "SIGNUP/SUBMIT_SKILLS_DETAILS_REQUEST",
  SUBMIT_SKILLS_DETAILS_FAILURE = "SIGNUP/SUBMIT_SKILLS_DETAILS_FAILURE",
  SUBMIT_SKILLS_DETAILS_SUCCESS = "SIGNUP/SUBMIT_SKILLS_DETAILS_SUCCESS",

  SIGNUP_INITIALISING = "SIGNUP/SIGNUP_INITIALISING",

  SIGNUP_FETCH_ALL_EDUCATIONS_SUCCESS = "SIGNUP/FETCH_ALL_EDUCATIONS_SUCCESS",
  FETCH_ALL_LANGUAGES_SUCCESS = "SIGNUP/FETCH_ALL_LANGUAGES_SUCCESS",
  SIGNUP_FETCH_ALL_LOCATIONS_SUCCESS = "SIGNUP/FETCH_ALL_LOCATIONS_SUCCESS",

  FETCH_CHAT_HISTORY_REQUEST = "FETCH_CHAT_HISTORY_REQUEST",
  FETCH_CHAT_HISTORY_SUCCESS = "FETCH_CHAT_HISTORY_SUCCESS",
  FETCH_CHAT_HISTORY_FAILURE = "FETCH_CHAT_HISTORY_FAILURE",
  EMPTY_CHAT_HISTORY = "EMPTY_CHAT_HISTORY",
  UPDATE_CHAT_LIST = "UPDATE_CHAT_LIST",
  EMPTY_CHAT_LIST = "EMPTY_CHAT_LIST",

  FETCH_THREADHISTORY_REQUEST = "FETCH_THREADHISTORY_REQUEST",
  FETCH_THREADHISTORY_SUCCESS = "FETCH_THREADHISTORY_SUCCESS",
  FETCH_THREADHISTORY_FAILURE = "FETCH_THREADHISTORY_FAILURE",


  FETCH_SIGNUP_FLOW_STAUTS_REQUEST = "FETCH_SIGNUP_FLOW_STAUTS_REQUEST",
  FETCH_SIGNUP_FLOW_STAUTS_SUCCESS = "FETCH_SIGNUP_FLOW_STAUTS_SUCCESS",
  FETCH_SIGNUP_FLOW_STAUTS_FAILURE = "FETCH_SIGNUP_FLOW_STAUTS_FAILURE",

  SIGNUP_FETCH_ALL_CATEGORY_SKILLS_SUCCESS = "SIGNUP/FETCH_ALL_CATEGORY_SKILLS_SUCCESS",
  SIGNUP_FETCH_ALL_CATEGORY_SKILLS_FAILURE = "SIGNUP/FETCH_ALL_CATEGORY_SKILLS_FAILURE",
  SIGNUP_FETCH_ALL_CATEGORY_SKILLS_REQUEST = "SIGNUP/FETCH_ALL_CATEGORY_SKILLS_REQUEST",
}

export type IAuthState = {
  access_level?: string;
  otperrormessage: string;
  isuserLogin?: boolean;
  verifytoken: string;
  authtoken: string | null;
  isotpverified: boolean | null;
  isotpreceived: boolean | null;
  currentuserinfo: ICurrentUserState;
};

export type IOtpState = {
  mobile: string | null;
};

export type IAuthPayload = {
  auth_token: string;
  entity_id: string;
  isotpverified: boolean | null;
  isotpreceived: boolean | null;
  otperrormessage: string;
  user_id: string;
  user_name: string;
  access_level?: string;
};

export type IAuthActionCreator = {
  type: string;
  payload: IAuthPayload;
};
